import React, { PropsWithChildren, useEffect, useRef } from 'react';
import { onExteriorClick } from '../../hooks/onExteriorClick';
import styles from './Dropdown.module.scss';

export const Dropdown = ({
    children, open, setOpen
}: Props) => {

    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (open) {
            return onExteriorClick(ref, () => setOpen(false));
        }
    }, [open, setOpen]);

    useEffect(() => {
        if (open) {
            const onKeyDown = (event: any) => {
                if (event.key === 'Escape') {
                    setOpen(false);
                }
            };
            document.addEventListener('keydown', onKeyDown);
            return () => document.removeEventListener('keydown', onKeyDown);
        }
    }, [open, setOpen]);

    return (
        <div ref={ref} className={styles.default}>
            {children}
        </div>
    );
};

type Props = PropsWithChildren<{
    open: boolean,
    setOpen: (newValue: boolean) => void
}>;
